import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  NAME = 'name',
  NAME_KEY = 'nameKey',
  MET = 'met',
  IS_DEFAULT = 'isDefault',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.NAME;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME,
      label: t('common.name'),
      key: TABLE_COLUMNS_IDS.NAME,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.NAME,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      label: t('common.nameKey'),
      key: TABLE_COLUMNS_IDS.NAME_KEY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.NAME_KEY,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.MET,
      label: t('common.met'),
      key: TABLE_COLUMNS_IDS.MET,
      type: 'number',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.MET,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.IS_DEFAULT,
      label: t('common.default'),
      key: TABLE_COLUMNS_IDS.IS_DEFAULT,
      type: 'boolean',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.IS_DEFAULT,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
